import styled from 'styled-components'
import Panel from 'components/Panel'
import InlineLoader from 'components/InlineLoader'
import Button from 'components/Button'
import { FeedbackContainer, ContentMailerContainer } from 'containers'

const BackButton = styled(Button)`
  margin-right: 20px;
`

const Guide = ({
  guide,
  step,
  nextHandler,
  backHandler,
  deviceId,
  isFetching
}) => {
  if (isFetching) {
    return <InlineLoader />
  }

  const mailButton = <ContentMailerContainer emailBody={step.text} />
  return (
    <Panel title={guide.text} buttons={mailButton}>
      <p dangerouslySetInnerHTML={{ __html: step.text }} />
      {backHandler && <BackButton onClick={backHandler}>Back</BackButton>}
      {nextHandler && (
        <Button primary onClick={nextHandler}>
          Next
        </Button>
      )}
      <FeedbackContainer category="guide" contentId={guide.guideId} />
    </Panel>
  )
}

export default Guide
